import styles from "./styles.module.scss";
import { CardCheckbox } from "./svg/CardCheckbox";
import plus from "@assets/img/emoji/plus.png";
import muscle from "@assets/img/emoji/muscle.png";
import heartinfire from "@assets/img/emoji/heartinfire.png";
import {
  getPlanDuration,
  getPlanPricing,
} from "src/routes/containers/paywalls/shared/components/plan/utils/getPlanDetails";
import { useSelector } from "react-redux";

const ProductsIcons = {
  muscle,
  heartinfire,
};
const CurrencyMap = {
  USD: "$",
  EUR: "€",
  CAD: "$",
  AUD: "$",
  GBP: "£",
};

export const PlanItem = ({
  plan,
  isDiscounted,
  checked,
  onSelect,
  duration,
  isWalky,
}) => {
  const activePlan = useSelector((state) => state.plans.activePlan);
  const {
    priceNew,
    priceOld,
    currency,
    discountPercentage,
    trialDiscountPercentage,
    trialPriceAmount,
    trialNoDiscountPriceAmount,
    trialPeriodDuration,
    trialPeriodUnit,
  } = getPlanPricing(plan);

  const isTrial =
    activePlan?.hasTrial && !activePlan.uiDisplayOptions.ignoreTrial;
  const isLegacyPlan = Boolean(activePlan?.uiDisplayOptions.legacyPlan);

  const finalPriceNew = isLegacyPlan && !isTrial ? priceNew : trialPriceAmount;
  const finalPriceOld =
    isLegacyPlan && !isTrial ? priceOld : trialNoDiscountPriceAmount;
  const finalDiscountPercentage =
    isLegacyPlan && !isTrial ? discountPercentage : trialDiscountPercentage;

  const isCombinedPlan = plan.uiDisplayOptions?.isCombined;

  return (
    <div
      className={
        isWalky && checked ? `${styles.plan} ${styles.checkedWalky}` : checked ? `${styles.plan} ${styles.checked}`: `${styles.plan}`
      }
      onClick={onSelect}
    >
      <div className={styles.container}>
        {isDiscounted && finalDiscountPercentage && (
          <div className={isWalky ? styles.discountBadgeWalky : styles.discountBadge}>
            {finalDiscountPercentage}% OFF
          </div>
        )}
        <div className={styles.planContent}>
          {isCombinedPlan ? (
            <div className={styles.combinedPlan}>
              <>
                <div className={styles.titleRow}>
                  <div className={styles.icon}>
                    <img src={ProductsIcons[plan.icon]} alt={plan.title} />
                  </div>
                  <p>{plan.title}</p>
                </div>
                <img className={styles.plusSign} src={plus} alt="plus" />

                <div className={styles.titleRow}>
                  <div className={styles.icon}>
                    <img
                      src={ProductsIcons[plan.secondIcon]}
                      alt={plan.secondTitle}
                    />
                  </div>
                  <p>{plan.secondTitle}</p>
                </div>
              </>
            </div>
          ) : (
            <div className={styles.titleRow}>
              <div className={styles.icon}>
                <img src={ProductsIcons[plan.icon]} alt={plan.title} />
              </div>
              <p>{plan.title}</p>
            </div>
          )}
          <div className={styles.price}>
            <div className={styles.priceText}>
              {isDiscounted ? (
                <>
                  <p className={styles.priceNew}>
                    {CurrencyMap[currency]}
                    {isTrial
                      ? `${finalPriceNew} first 
                          ${
                            trialPeriodDuration === 1 ? "" : trialPeriodDuration
                          }
                         ${(trialPeriodDuration === 1
                           ? trialPeriodUnit.replace("S", "")
                           : trialPeriodUnit
                         ).toLowerCase()}`
                      : `${finalPriceNew} per ${getPlanDuration(duration)}`}
                  </p>
                  <p className={`${styles.priceOld} ${styles.isDiscounted}`}>
                    {CurrencyMap[currency]}
                    {finalPriceOld}
                  </p>
                </>
              ) : (
                <p className={styles.priceOld}>
                  {CurrencyMap[currency]}
                  {finalPriceOld} per {getPlanDuration(duration)}
                </p>
              )}
            </div>
            <div className={styles.checkbox}>
              <CardCheckbox checked={checked} isWalky={isWalky} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
